import React from 'react';

import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Subcategory, Talent } from '@libs/graphql-types';
import Chip from '@libs/ui/components/chip';

interface CategoriesListProps {
  talent: Talent;
}

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
}));

const CategoriesList = ({ talent }: CategoriesListProps) => {
  const classes = useStyles();
  const subcategories = (talent?.subcategories as Subcategory[]) || [];

  if (!subcategories.length) {
    return <></>;
  }

  return (
    <Grid spacing={2} container className={classes.container}>
      {subcategories.map((i) => (
        <Grid key={i.id} item>
          <Chip color="grey" size="small" label={i.name} />
        </Grid>
      ))}
    </Grid>
  );
};

export default CategoriesList;
